import styled from "styled-components/macro";

export const Card = styled.article`
  border-radius: 24px;
  background: linear-gradient(
    180deg,
    #eeeff0 0%,
    #e6e9ff 100%
  );
  border: 1px solid #B4B4B4;
  overflow: hidden;
`

export const Button = styled.a`
  padding: 18px 0;
  font-weight: 500;
  color: inherit;
  background-color: #F8F8F8;
  border: 1px solid #141414;
  height: 54px;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  line-height: 18px;
  text-decoration: none;
  transition: 0.2s;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: #000;
    color: #fff;
    transition: 0.2s;
    border: 1px solid #000;
  }
`

